export const siteConfig = {
  name: '韩漫画网',
  tagline: '下拉式免费漫画阅读平台',
  description: '韩漫画网拥有下拉式免费漫画和韩漫在线观看功能，涵盖韩国漫画大全资源，操作简单内容全面，是您漫画收藏好帮手。',
  url: 'https://www.hanmanhua.com',
  email: 'contact@hanmanhua.com',
  founded: '2020',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '恋爱', href: '/category/romance' },
  { label: '动作', href: '/category/action' },
  { label: '奇幻', href: '/category/fantasy' },
  { label: '悬疑', href: '/category/thriller' },
  { label: '搞笑', href: '/category/comedy' },
  { label: '关于我们', href: '/about' },
];